import { forwardRef, type ComponentPropsWithoutRef } from 'react'
import { formatCredits } from '@/features/ai/lib/money'
import type { Deficit } from './lib/packageFit'
import { useMessages } from '@/i18n'
import { messages } from './messages'

interface Props extends ComponentPropsWithoutRef<'span'> {
  deficit: Deficit | null
}

/**
 * Подзаголовок окна «Купить кредиты». Текущий баланс тут НЕ пишем: он виден в
 * самой студии, а в окне покупки только отвлекал. Говорим лишь о том, зачем
 * пришли: когда окно открыл отказ прогона, называем, сколько кредитов не
 * хватило (числа приходят из САМОГО отказа и описывают упавший прогон).
 *
 * `forwardRef` + проброс `rest` — не украшение: подзаголовок подставляется в
 * `DialogDescription asChild`, а Slot передаёт вниз `id` описания, на который
 * ссылается `aria-describedby` самого диалога. Без них скринридер остался бы
 * без описания, а Radix ругался бы в консоль.
 *
 * Без отказа описание остаётся только для скринридера (`sr-only`): пустым
 * `DialogDescription` оставлять нельзя.
 */
export const TopUpSubtitle = forwardRef<HTMLSpanElement, Props>(
  ({ deficit, className, ...rest }, ref) => {
    const m = useMessages(messages)
    return (
      <span ref={ref} className={deficit ? className : 'sr-only'} {...rest}>
        {deficit ? m.runNeeds(formatCredits(deficit.required)) : m.choosePackage}
      </span>
    )
  },
)
TopUpSubtitle.displayName = 'TopUpSubtitle'
